module.exports = __webpack_public_path__ + "static/media/variable.3f11387f.svg";